module.exports = __webpack_public_path__ + "img/ic_procurement.bf632476.png";